import styled from 'styled-components';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';

import { Select } from 'components/Form/subcomponents/Select';
import { medias, colors } from 'assets/styled/tokens';

import selectDropdown from 'assets/icons/select-dropdown-up.svg';
export const TransparentBg = styled.div`
  background: rgba(0, 0, 0, 0.7);
  //opacity: 0.5;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  padding: 70px 0;
  z-index: 5;
  overflow-y: auto;
`;
export const Modal = styled.div`
  min-height: 663px;
  width: 336px;
  border-radius: 12px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  //padding: 18px;
  @media (min-width: ${medias.desktopSm}) {
    min-height: 695px;
    width: 693px;
  }
`;
export const Header = styled.div`
  display: flex;
  padding: 18px;
  justify-content: space-between;
  font-family: Blinker;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  color: ${colors.primary};
  align-items: center;
  border-bottom: 1px solid #dddddd;
  svg {
    :hover {
      cursor: pointer;
    }
    height: 12px;
    width: 12px;
  }
`;
export const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 18px;
`;

export const StyledFormGroup = styled(FormGroup)`
  label {
    font-size: 24px;
    margin-bottom: 20px;
  }
  input {
    width: ${props => props.width};
  }
`;
export const StyledSelect = styled(Select)`
  width: 100%;
  height: 32px;
  input {
    width: 100%;
    height: 32px;
  }
  @media (min-width: ${medias.desktopSm}) {
    //width: 569px;
    height: 48px;
    input {
      height: 48px;
    }
  }
  ul {
    background-color: #fff;
    max-height: 250px;
    div > div input {
      width: 100%;
      border: none;
      background: url(${selectDropdown}) right 10px center no-repeat;
      ::placeholder {
        padding-left: 24px;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.3px;
        font-weight: 400;
      }
    }
    div > div img {
      right: auto;
      left: 12px;
      height: 14px;
      width: 14px;
    }
    section {
      li {
        height: 32px;
        :hover {
          background-color: #f5f3f1;
          cursor: pointer;
        }
        input {
          height: 32px;
        }
        label {
          font-size: 12px;
          margin: 0;
          height: 32px;
          //top: 0;
        }
      }
    }
  }
`;
// export const StyledSelect = styled(Select)`
//   width: 299px;
//   height: 48px;
//   input {
//     height: 48px;
//     width: 100%;
//   }

//   ul {
//     max-height: 250px;
//     section {
//       li {
//         height: 24px;
//         label {
//           font-size: 12px;
//         }
//       }
//     }
//   }
//   @media (min-width: ${medias.desktopSm}) {
//     width: 569px;
//   }
// `;
export const ObservationInfo = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #888888;
  margin-bottom: 12px;
`;
export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  //gap: 16px;
  justify-content: space-between;
  @media (min-width: ${medias.desktopSm}) {
    justify-content: flex-start;
    gap: 16px;
  }
`;
export const SaveButton = styled.button`
  width: 85px;
  height: 32px;
  background-color: #f38a00;
  border-radius: 4px;
  color: #fff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${medias.desktopSm}) {
    height: 48px;
  }
`;
export const CleanButton = styled.button`
  width: 168px;
  height: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border-radius: 4px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  color: #c25446;
  border: 1px solid #e5e5e5;
  @media (min-width: ${medias.desktopSm}) {
    height: 48px;
  }
`;
export const ErrorText = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #c25446;
  margin-bottom: 12px;
`;
